/** BitLocker ProtectionStatus: 1 / "On" = protectors actively protecting. */
export const isBitlockerProtectionOn = (status) =>
  status === 1 ||
  status === "1" ||
  status === true ||
  status === "On" ||
  status === "Enabled"

export const getBitlockerProtectionLabel = (protectionStatus, volumeStatus) => {
  if (isBitlockerProtectionOn(protectionStatus)) return "Enabled"
  // Volume encrypted but ProtectionStatus Off → usually suspended / unprotected.
  if (volumeStatus === 1 || volumeStatus === "1") return "Suspended"
  return "Disabled"
}

export const getBitlockerVolumeStatusLabel = (status) => {
  switch (status) {
    case 0:
    case "0":
      return "Fully Decrypted"
    case 1:
    case "1":
      return "Fully Encrypted"
    case 2:
    case "2":
      return "Encryption In Progress"
    case 3:
    case "3":
      return "Decryption In Progress"
    default:
      return "Unknown"
  }
}
